'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import { localStore } from 'utils/localStorage';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _setup = require('redux/modules/setup');

var _Home = require('./../Home/');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _exuWhite = require('assets/img/membership/exuWhite.png');

var _exuWhite2 = _interopRequireDefault(_exuWhite);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

var _expiredVoucherImage = require('assets/img/voucher/expiredVoucherImage.jpg');

var _expiredVoucherImage2 = _interopRequireDefault(_expiredVoucherImage);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _lib = require('helpers/lib');

var _support = require('helpers/support');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExchangeReward = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    PACKAGE_DETAIL: state.voucher.PACKAGE_DETAIL,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST,
    EXCHANGE_REWARD: state.voucher.EXCHANGE_REWARD,
    exchangeBranch: state.voucher.exchangeBranch,
    exchangeShop: state.voucher.exchangeShop,
    user: state.auth.user
  };
}, {
  getRewardDetail: voucherActions.getRewardDetail,
  changeExchangeShop: voucherActions.changeExchangeShop,
  resetExchangeShop: voucherActions.resetExchangeShop,
  changeTab: voucherActions.changeTab,
  getAllReward: voucherActions.getAllReward,
  beforeExchangeReward: voucherActions.beforeExchangeReward,
  exchangeReward: voucherActions.exchangeReward,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  setPathName: _setup.setPathName,
  showDownloadAppPopup: _setup.showDownloadAppPopup
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExchangeReward, _Component);

  function ExchangeReward(props) {
    (0, _classCallCheck3.default)(this, ExchangeReward);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExchangeReward.__proto__ || (0, _getPrototypeOf2.default)(ExchangeReward)).call(this, props));

    _this.state = {
      showErr: false,
      contentErr: {
        title: { text: 'Lỗi', type: 'error' },
        message: []
      },
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'success' },
        message: []
      },
      showBranch: false,
      changeData: false
    };

    _this.getButtonByShop = _this.getButtonByShop.bind(_this);
    _this.renderAllReward = _this.renderAllReward.bind(_this);
    _this.hideFlow = _this.hideFlow.bind(_this);
    _this.hideError = _this.hideError.bind(_this);
    _this.onExchange = _this.onExchange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ExchangeReward, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getAllReward();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          params = _props.params,
          query = _props.location.query;

      if (query && query.branch) {
        var content = {
          title: { text: 'Nhắc Nhở', type: 'success' },
          message: [{ text: 'Nhớ chọn chi nhánh để sử dụng khuyến mãi bạn nhé!' }],
          button: [{
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }]
        };
        this.setState({ contentFlow: content, showFlow: true });
      }
      this.props.getRewardDetail(params.handle);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetExchangeShop();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.params.handle !== nextProps.params.handle && nextProps.params.handle) {
        this.props.getRewardDetail(nextProps.params.handle);
      }
    }
  }, {
    key: 'downApp',
    value: function downApp(platform) {
      if (platform === 'ios') {
        window.location.assign(_config2.default.iosLink);
      }
      if (platform === 'android') {
        window.location.assign(_config2.default.androidLink);
      }
    }
  }, {
    key: 'getButtonExchangeReward',
    value: function getButtonExchangeReward(_ref) {
      var _this3 = this;

      var type = _ref.type,
          reward = _ref.reward;

      switch (type) {
        case 'EXCHANGE_REWARD_SUCCESS':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Ưu Đãi Của Tôi',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toMyReward();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this3.hideFlow();
            }
          }];
        case 'REWARD_EXISTED':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Chi Tiết Ưu Đãi',
            onClick: function onClick() {
              return _this3.toBookingReward(reward.couponCode.code);
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this3.hideFlow();
            }
          }];
        case 'EXCHANGE_REWARD_FAIL':
          return [{
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this3.hideError();
            }
          }];
        case 'CONFIRM_EXCHANGE_REWARD':
          return [{
            text: 'Chắc chắn',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.exchange(reward);
              _reactGa2.default.event({
                category: 'Promotion',
                action: 'Clicked Exchange button',
                label: '' + reward.packId
              });
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this3.hideFlow();
            }
          }];
        case 'REQUIRE_LOGIN':
          return [{
            text: 'Đăng nhập',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toLogin();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this3.hideFlow();
            }
          }];
        case 'REQUIRE_EXCHANGE_SHOP':
          return [{
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this3.hideFlow();
            }
          }];
        case 'REWARD_FOR_APP':
          return [{
            iconFont: 'fa fa-apple fa-3x',
            text: 'IOS',
            onClick: function onClick() {
              _this3.downApp('ios');
            }
          }, {
            iconFont: 'fa fa-android fa-3x',
            text: 'Android',
            onClick: function onClick() {
              _this3.downApp('android');
            }
          }];
        case 'CATEGORY_SERVICE_FOR_APP':
          return [{
            iconFont: 'fa fa-apple fa-3x',
            text: 'IOS',
            onClick: function onClick() {
              _this3.downApp('ios');
            }
          }, {
            iconFont: 'fa fa-android fa-3x',
            text: 'Android',
            onClick: function onClick() {
              _this3.downApp('android');
            }
          }];
        default:
          break;
      }
      return [];
    }
  }, {
    key: 'getButtonByShop',
    value: function getButtonByShop(coupon) {
      var _this4 = this;

      if (coupon && coupon.packageService) {
        var shop = coupon.packageService.shop;

        var btn = {};
        if (shop && shop.isBooking) {
          btn = {
            text: 'Đặt Lịch',
            onClick: function onClick() {
              _this4.hideFlow();
              _this4.toBooking(coupon);
            }
          };
        } else if (shop && !shop.isBooking) {
          btn = {
            text: 'Gọi Đặt Lịch',
            onClick: function onClick() {
              _this4.hideFlow();
              _this4.toCallShop(shop);
            }
          };
        }
        return btn;
      }
      return {};
    }
  }, {
    key: 'toLogin',
    value: function toLogin() {
      var _props2 = this.props,
          history = _props2.history,
          data = _props2.PACKAGE_DETAIL.data;

      this.props.setPathName('/uu-dai/' + (data && data.handle ? data.handle : ''));
      history.push('/dang-nhap');
    }
  }, {
    key: 'toMyReward',
    value: function toMyReward() {
      this.props.changeTab('myReward');
      this.props.history.push('/uu-dai');
    }
    // toBooking(code, shop, service, coupon) {
    //   const { resetBooking, setDefaultBooking, history } = this.props;
    //   resetBooking();
    //   changeShopBeforeBooking(shop);
    //   const bookingServices = [
    //     { service: service._id, number: 1, name: service.name },
    //   ];
    //   const submit = { bookingServices, code, shop };
    //   if (coupon) {
    //     submit.coupon = coupon;
    //   }
    //   setDefaultBooking(submit);
    //   history.push(`/dat-lich`);
    // }

  }, {
    key: 'toBooking',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(coupon) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.showDownloadAppPopup();
                // console.warn('vào booking coupon', coupon);
                // const {
                //   packageService: { shop, serviceRewrite: service },
                //   code,
                // } = coupon;
                // const {
                //   resetBooking,
                //   setDefaultBooking,
                //   history,
                //   changeShopBeforeBooking,
                //   user,
                // } = this.props;
                // resetBooking();
                // changeShopBeforeBooking(shop, user);
                // let bookingServices = [];
                // if (service && service._id) {
                //   bookingServices = [
                //     { service: service._id, number: 1, name: service.name },
                //   ];
                // } else {
                //   console.log('dịch vụ không tồn tại', service);
                // }
                // const submit = { bookingServices, code, shop, coupon };
                // setDefaultBooking(submit);
                // history.push(`/dat-lich`);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toBooking(_x) {
        return _ref2.apply(this, arguments);
      }

      return toBooking;
    }()
  }, {
    key: 'toCallShop',
    value: function toCallShop(shop) {
      if (shop) {
        window.open('tel:' + (0, _lib.getPhone)(shop.phone));
      }
    }
  }, {
    key: 'toBookingReward',
    value: function toBookingReward(code) {
      this.props.history.push('/uu-dai-cua-toi/' + code);
    }
  }, {
    key: 'toRewardDetail',
    value: function toRewardDetail(reward) {
      this.props.history.push('/uu-dai/' + reward.handle);
    }
  }, {
    key: 'moreDetail',
    value: function moreDetail(shopName) {
      _reactGa2.default.event({
        category: 'Shop',
        action: 'Clicked Shop Card from voucher',
        label: '' + shopName
      });
    }
  }, {
    key: 'exchange',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(item) {
        var exchangeReward, params, res, content, couponCode;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                exchangeReward = this.props.exchangeReward;
                params = void 0;

                if (this.props.location && this.props.location.query) {
                  params = this.props.location.query;
                }
                _context2.next = 5;
                return exchangeReward(item, params);

              case 5:
                res = _context2.sent;
                content = {};

                if (res.success) {
                  couponCode = res.data.couponCode;

                  if (res.type === 'TO_BOOKING') {
                    this.toBooking(couponCode);
                  } else {
                    content = res.content;
                    content.button = this.getButtonExchangeReward({
                      type: res.type,
                      reward: res.data
                    });
                    this.setState({ contentFlow: content, showFlow: true });
                  }
                } else {
                  content = res.content;
                  content.button = this.getButtonExchangeReward({
                    type: res.type,
                    reward: res.data
                  });
                  this.setState({ contentErr: content, showErr: true });
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function exchange(_x2) {
        return _ref3.apply(this, arguments);
      }

      return exchange;
    }()
  }, {
    key: 'onExchange',
    value: function onExchange(e, item) {
      e.stopPropagation();
      this.props.showDownloadAppPopup();
      // const res = this.props.beforeExchangeReward(item);
      // const contentFlow = { ...res.content };
      // contentFlow.button = this.getButtonExchangeReward({
      //   type: res.type,
      //   reward: res.data,
      // });
      // this.setState({ contentFlow, showFlow: true });
    }
  }, {
    key: 'onChangeBranchShop',
    value: function onChangeBranchShop(shop) {
      this.props.changeExchangeShop(shop);
    }
  }, {
    key: 'showError',
    value: function showError() {
      this.setState({ showErr: true });
    }
  }, {
    key: 'hideError',
    value: function hideError() {
      this.setState({ showErr: false });
    }
  }, {
    key: 'showFlow',
    value: function showFlow() {
      this.setState({ showFlow: true });
    }
  }, {
    key: 'hideFlow',
    value: function hideFlow() {
      this.setState({ showFlow: false });
    }
  }, {
    key: 'showBranch',
    value: function showBranch() {
      this.setState({ showBranch: true });
    }
  }, {
    key: 'hideBranch',
    value: function hideBranch() {
      this.setState({ showBranch: false });
    }
  }, {
    key: 'renderAllReward',
    value: function renderAllReward(item) {
      var _this5 = this;

      var userNo = this.props.userNo;


      var _item = {
        title: item.campaign.name,
        countDown: _support.Helper.distanceTwoDate(item.campaign.limitDate),
        forRank: item.campaign.forRank ? item.campaign.forRank : ''
      };
      var result = [];
      if (item) {
        _item = (0, _extends3.default)({}, _item, {
          image: item.image,
          newPrice: item.displayValue,
          oldPrice: item.service.price,
          shopName: item.shop.name,
          address: item.shop.addressDisplay ? item.shop.addressDisplay : item.shop.address,
          exu: item.pointReward,
          allowExchange: true,
          handle: item.handle,
          packId: item._id,
          shop: item.shop,
          service: item.service
        });
        if (_item.forRank && _item.forRank.type && userNo !== -1) {
          var campaignNo = _support.Helper.rankNo(_item.forRank.type);
          _item.allowExchange = userNo >= campaignNo;
        }
        result.push(_react2.default.createElement(_components.RewardItem, {
          item: _item,
          onPress: function onPress() {
            return _this5.toRewardDetail(_item);
          },
          onExchange: function onExchange(e) {
            return _this5.onExchange(e, _item);
          }
        }));
        return result;
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this6 = this;

      var styles = require('./Voucher.scss');
      var _props3 = this.props,
          params = _props3.params,
          data = _props3.PACKAGE_DETAIL.data,
          exchangeBranch = _props3.exchangeBranch,
          exchangeShop = _props3.exchangeShop;
      var showBranch = this.state.showBranch;

      var item = (0, _extends3.default)({}, data, { packId: data._id, exu: data.pointReward });
      var campaign = data.campaign,
          service = data.service,
          shop = data.shop,
          displayValue = data.displayValue,
          image = data.image,
          pointReward = data.pointReward;

      var expired = new Date() > (0, _moment2.default)(campaign.endDate);
      return _react2.default.createElement(
        'div',
        {
          id: 'voucherDetail',
          className: styles.voucherDetail,
          ref: 'voucherDetail'
        },
        _react2.default.createElement(
          'div',
          { className: styles.modalBody },
          _react2.default.createElement(
            'div',
            { className: styles.image },
            _react2.default.createElement('i', {
              className: 'fa fa-angle-left',
              onClick: this.props.history.goBack
            }),
            expired ? _react2.default.createElement('img', { src: _expiredVoucherImage2.default }) : _react2.default.createElement('img', { src: image || _defaultVoucherImage2.default, alt: 'H\xECnh avatar' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.primaryInfo },
            _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                campaign.name
              ),
              !!(exchangeBranch && exchangeBranch.length > 1) && _react2.default.createElement(
                'div',
                { className: styles.branch },
                _react2.default.createElement(_components.SelectShop, {
                  show: showBranch,
                  placeHolder: 'Vui l\xF2ng ch\u1ECDn chi nh\xE1nh.',
                  activeShop: exchangeShop,
                  active: 'true',
                  onHide: this.hideBranch.bind(this),
                  onShow: this.showBranch.bind(this),
                  onChange: this.onChangeBranchShop.bind(this),
                  data: exchangeBranch
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.shop },
                _react2.default.createElement('img', { src: '/icon/svg/shop.svg', alt: '' }),
                shop.name,
                ' -',
                ' ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: '/' + shop.handle,
                    onClick: function onClick() {
                      return _this6.moreDetail(shop.name);
                    }
                  },
                  'Th\xF4ng tin shop'
                )
              ),
              !!(exchangeShop && exchangeBranch.length > 1) && _react2.default.createElement(
                'div',
                { className: styles.address },
                _react2.default.createElement('img', { src: '/icon/svg/map.svg', alt: '' }),
                exchangeShop.addressDisplay || exchangeShop.address
              ),
              !!(!exchangeBranch || exchangeBranch.length <= 1) && _react2.default.createElement(
                'div',
                { className: styles.address },
                _react2.default.createElement('img', { src: '/icon/svg/map.svg', alt: '' }),
                shop.addressDisplay || shop.address
              ),
              _react2.default.createElement(
                'div',
                { className: styles.service },
                _react2.default.createElement('img', { src: '/icon/svg/flower.svg', alt: '' }),
                service.name
              ),
              _react2.default.createElement(
                'div',
                { className: styles.times },
                _react2.default.createElement('img', { src: '/icon/svg/calendar.svg', alt: '' }),
                'T\u1EEB ' + (0, _moment2.default)(new Date(campaign.startDate)).format('DD/MM/YYYY') + ' \u0111\u1EBFn ' + (0, _moment2.default)(new Date(campaign.endDate)).format('DD/MM/YYYY')
              ),
              _react2.default.createElement(
                'div',
                { className: styles.price },
                _react2.default.createElement('img', { src: '/icon/svg/gift.svg', alt: '' }),
                _react2.default.createElement(
                  'span',
                  { className: styles.newPrice },
                  (0, _numeral2.default)(displayValue).format('0,0') + ' đ'
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.oldPrice },
                  (0, _numeral2.default)(service.price).format('0,0') + ' đ'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.description },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                ' M\xF4 t\u1EA3 d\u1ECBch v\u1EE5:'
              ),
              _react2.default.createElement('div', {
                className: styles.content,
                dangerouslySetInnerHTML: { __html: service.description }
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.condition },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                '\u0110i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng'
              ),
              _react2.default.createElement('div', {
                className: styles.content,
                dangerouslySetInnerHTML: { __html: campaign.condition }
              })
            )
          ),
          _react2.default.createElement(_Home.Promotion, {
            history: this.props.history,
            title: 'Ưu đãi khác',
            promotionHandle: params.handle
          }),
          _react2.default.createElement(
            'div',
            { className: styles.btnGroup },
            _react2.default.createElement(
              'div',
              {
                className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.available + ' ' + styles.exchangeBtn,
                onClick: function onClick(e) {
                  return _this6.onExchange(e, item);
                }
              },
              pointReward ? '\u0110\u1ED4I ' + pointReward : 'LẤY VOUCHER',
              pointReward ? _react2.default.createElement('img', { src: _exuWhite2.default }) : null
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var styles = require('./Voucher.scss');
      var rewardData = this.props.ALL_REWARD_LIST.data;
      var _state = this.state,
          showErr = _state.showErr,
          contentErr = _state.contentErr,
          showFlow = _state.showFlow,
          contentFlow = _state.contentFlow;
      var _props$PACKAGE_DETAIL = this.props.PACKAGE_DETAIL,
          data = _props$PACKAGE_DETAIL.data,
          loading = _props$PACKAGE_DETAIL.loading;

      return _react2.default.createElement(
        'div',
        { style: { display: 'block', width: '100%', height: '100%' } },
        data && !loading && this.renderContent(),
        !data && !loading && _react2.default.createElement(
          'div',
          { className: styles.notfound },
          _react2.default.createElement(
            'div',
            { className: styles.textNotFound },
            '\u01AFu \u0111\xE3i kh\xF4ng t\u1ED3n t\u1EA1i'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.headerBox },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement('i', { className: 'fa fa-gift' }),
                _react2.default.createElement(
                  'h1',
                  { className: styles.title },
                  '\u01AFu \u0111\xE3i hi\u1EC7n h\xE0nh'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.right, style: { marginTop: 5 } },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: 'uu-dai' },
                  _react2.default.createElement(
                    'div',
                    { className: styles.seeMore },
                    'Xem th\xEAm',
                    _react2.default.createElement(_reactBootstrap.Glyphicon, (0, _defineProperty3.default)({
                      className: styles.arrowRight,
                      glyph: 'menu-right'
                    }, 'className', styles.arrowRight))
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.listVoucher },
            !!(rewardData && rewardData.length) && rewardData.slice(0, 3).map(function (item) {
              return _this7.renderAllReward(item);
            })
          )
        ),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_flow',
          show: showFlow,
          onHide: this.hideFlow,
          title: contentFlow.title,
          message: contentFlow.message,
          button: contentFlow.button,
          closeButton: true
        }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_error',
          show: showErr,
          onHide: this.hideError,
          title: contentErr.title,
          message: contentErr.message,
          button: contentErr.button,
          closeButton: true
        })
      );
    }
  }]);
  return ExchangeReward;
}(_react.Component), _class2.propTypes = {
  // @data
  params: _react.PropTypes.object,
  ALL_REWARD_LIST: _react.PropTypes.object,
  MY_REWARD_LIST: _react.PropTypes.object,
  userNo: _react.PropTypes.number,
  PACKAGE_DETAIL: _react.PropTypes.object,
  EXCHANGE_REWARD: _react.PropTypes.object,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  exchangeShop: _react.PropTypes.object,
  exchangeBranch: _react.PropTypes.array,
  // @action
  getRewardDetail: _react.PropTypes.func,
  changeExchangeShop: _react.PropTypes.func,
  resetExchangeShop: _react.PropTypes.func,
  beforeExchangeReward: _react.PropTypes.func,
  exchangeReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  getAllReward: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  setPathName: _react.PropTypes.func.isRequired,
  showDownloadAppPopup: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = ExchangeReward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Voucher/ExchangeReward.js
// module id = 1640
// module chunks = 0